export class Payment {
  dispositionId?: number;
  id?: number;
  status?: string;
  paymentType?: string;
  paymentDetails?: string;
  remarks?: string;
  active?: boolean;
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
}
